import React from 'react';
import { observer } from "mobx-react";
import LoaderV1 from 'ReactApp/Components/LoaderV1/LoaderV1';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartOrderCreateProcessV1Props = {
    showableCart: ShowableCart
}

const CartOrderCreateProcessV1 = observer((props: CartOrderCreateProcessV1Props) => {

    return (
        <div 
            className="
                info-block-v1 
                box-v1 
                box-v1_filling-type-contained 
                box-v1_filling-color-type-gray 
                info-block-v1_text-color-type-text
            "
            style={{
                marginBottom: '3rem'
            }}
            >
                <LoaderV1 />
                <div className="info-block-v1__content">
                    <h1 className="title js-catalog-title">
                        Заказ <strong>№{props.showableCart.order.formattedNumber}</strong>&nbsp; создается!
                    </h1>
                    <p className="p-v1 p-v1_text-color-type-text" style={{
                        lineHeight: '3rem'
                    }}>
                        Пожалуйста, дождитесь окончания процесса чтобы попасть на страницу Вашего заказа.
                    </p>
                </div>
        </div>
    );

})

export default CartOrderCreateProcessV1;